function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Tracker INSTEAD.

import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import EventTracker from "../utils/tracker/EventTracker";
import filterPayload from "../utils/tracker/filterPayload";
import TrackerContext from "./context";
var globalState = {
  getConfig: null,
  source: null
};
export var trackEvent = function trackEvent() {
  var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown Event';
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _globalState = globalState,
    getConfig = _globalState.getConfig,
    source = _globalState.source;
  var verifiedPayload = payload !== null ? payload : {};
  if (!eventName || !verifiedPayload || !defaultData || !getConfig) {
    var msg = 'trackEvent missing arguments';
    if (typeof window !== 'undefined') {
      window.datadogLogs.logger.error(msg, {
        eventName: eventName,
        payload: verifiedPayload
      });
    }
    // eslint-disable-next-line no-console
    return console.error(msg);
  }
  var filteredPayload = filterPayload({
    source: source,
    payload: verifiedPayload,
    defaultData: defaultData
  });
  return EventTracker.trackClick(eventName, filteredPayload, _objectSpread(_objectSpread({}, getConfig()), config));
};
var setGlobalState = function setGlobalState(getConfig, source) {
  globalState = {
    getConfig: getConfig,
    source: source
  };
};

/**
 * @visibleName Tracker DEPRECATED
*/
var Tracker = /*#__PURE__*/function (_Component) {
  function Tracker(props) {
    var _this;
    _classCallCheck(this, Tracker);
    _this = _callSuper(this, Tracker, [props]);
    var _this$props = _this.props,
      getConfig = _this$props.getConfig,
      source = _this$props.source;
    setGlobalState(getConfig, source);
    _this.eventTracker = _this.eventTracker.bind(_this);
    return _this;
  }
  _inherits(Tracker, _Component);
  return _createClass(Tracker, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        eventTracker: this.eventTracker
      };
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      var _this$props2 = this.props,
        getConfig = _this$props2.getConfig,
        source = _this$props2.source;
      setGlobalState(getConfig, source);
    }
  }, {
    key: "eventTracker",
    value: function eventTracker() {
      var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown Event';
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaultData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$props3 = this.props,
        source = _this$props3.source,
        getConfig = _this$props3.getConfig;
      setGlobalState(getConfig, source);
      trackEvent(eventName, payload, defaultData);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TrackerContext.Provider, {
        value: this.eventTracker
      }, Children.only(this.props.children));
    }
  }]);
}(Component);
export { Tracker as default };
Tracker.propTypes = {
  children: PropTypes.element.isRequired,
  source: PropTypes.string.isRequired,
  getConfig: PropTypes.func.isRequired
};
Tracker.childContextTypes = {
  eventTracker: PropTypes.func
};